import { sendSignInLinkToEmail } from "firebase/auth";
import { auth } from "../firebase";

const LS_EMAIL = "bd_ml_email";
const LS_SID = "bd_ml_sid";
const LS_SID_TS = "bd_ml_sid_ts";

function newSid() {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

export function getStoredMagicLinkEmail() {
  return localStorage.getItem(LS_EMAIL) || "";
}

export function clearMagicLinkLocalState() {
  localStorage.removeItem(LS_EMAIL);
  localStorage.removeItem(LS_SID);
  localStorage.removeItem(LS_SID_TS);
}

export async function requestDeviceBoundMagicLink(email) {
  const sid = newSid();

  localStorage.setItem(LS_EMAIL, email);
  localStorage.setItem(LS_SID, sid);
  localStorage.setItem(LS_SID_TS, String(Date.now()));

  const actionCodeSettings = {
    url: `${window.location.origin}/finish-signin?sid=${encodeURIComponent(sid)}`,
    handleCodeInApp: true,
  };

  await sendSignInLinkToEmail(auth, email, actionCodeSettings);
}

export function getStoredSid() {
  return localStorage.getItem(LS_SID) || "";
}